import { styled } from '../../../Styles/stitches.config'
import { StyledCheckbox } from '../../Checkbox/styles'
import { StyledRadioButton } from '../../RadioButton/styles'
import { StyledSwitch } from '../../Switch/styles'

export const StyledCheckedContainer = styled('div', {
    display: 'inline-block',
    lineHeight: 0,
    verticalAlign: 'middle',
})

export const HiddenInput = styled('input', {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    m: -1,
    overflow: 'hidden',
    p: 0,
    position: 'absolute',
    size: 1,
    whiteSpace: 'nowrap',

    '@canHover': {
        '&:hover': {
            [`+ ${StyledCheckbox}, + ${StyledRadioButton}`]: {
                bgc: '$neutral200',
            },

            [`+ ${StyledSwitch}`]: {
                '&::after': {
                    bgc: '$neutral200',
                },
            },
        },
    },

    '&:checked': {
        [`+ ${StyledCheckbox}, + ${StyledSwitch}`]: {
            bgc: '$primary600',
        },

        [`+ ${StyledCheckbox}, + ${StyledRadioButton}`]: {
            '&::after': {
                display: 'block',
            },
        },

        '@canHover': {
            '&:hover': {
                [`+ ${StyledCheckbox}`]: {
                    '&::after': {
                        bc: '$neutral200',
                    },
                },

                [`+ ${StyledRadioButton}`]: {
                    bgc: '$primary200',
                },
            },
        },

        [`+ ${StyledSwitch}`]: {
            bc: '$primary600',

            '&::after': {
                transform: 'translateX(15px)',
            },
        },
    },

    '&:disabled': {
        pointerEvents: 'none',

        [`+ ${StyledCheckbox}, + ${StyledRadioButton}, + ${StyledSwitch}`]: {
            cursor: 'default',
            pointerEvents: 'none',
        },

        [`+ ${StyledCheckbox}, + ${StyledRadioButton}`]: {
            bc: '$neutral300',
            bgc: '$neutral100',
        },

        [`+ ${StyledRadioButton}`]: {
            '&::after': {
                bgc: '$neutral100',
            },
        },

        [`+ ${StyledSwitch}`]: {
            bc: '$neutral200',
            bgc: '$neutral200',

            '&::after': {
                bc: '$neutral300',
                bgc: '$neutral100',
            },
        },

        '&:checked': {
            [`+ ${StyledCheckbox}`]: {
                '&::after': {
                    bc: '$neutral300',
                },
            },

            [`+ ${StyledRadioButton}`]: {
                '&::after': {
                    bgc: '$neutral300',
                },
            },

            [`+ ${StyledSwitch}`]: {
                bc: '$neutral300',
                bgc: '$neutral300',
            },
        },
    },
})
